<template>
<card>
    <b-card-header class="border-0">
        <h3 class="mb-0" style="font-size: 18px; font-weight: bold; color: #2c3e50;">SENARAI PENJAWAT AWAM TELAH SELESAI</h3>
    </b-card-header>
<br/>
    <!-- <CarianBaharu
      @carianProgram="searchProgram"
      @resetPaging="resetPaging"
    ></CarianBaharu> -->

    <el-table v-loading="loading" class="table-responsive table" header-row-class-name="thead-light"
    :header-cell-style="{
    background: '#f6f9fc',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '16px'
  }" :cell-style="{
    fontWeight: 600,
    color: '#000',
    fontSize: '14px'
  }"
     :data="SenaraiPenjawatAwam" style="width: 100%">
        <el-table-column align="center" type="index" :index="indexMethod" width="100px">
        </el-table-column>

        <el-table-column label="NAMA" prop="CONm" min-width="250px" :formatter="uppercase">
        </el-table-column>
        <el-table-column label="NO KAD PENGENALAN" prop="ICNo" min-width="250px" />
        <el-table-column label="JAWATAN" prop="jawatan" min-width="250px">
        </el-table-column>


        <el-table-column label="Tindakan" min-width="150px" align="right" fixed="right">
            <template v-slot="{ row }">
                <base-button v-if="true" size="xl" icon type="primary" class="mb-2" @click="showVal(row)">
                    <span class="btn-inner--icon"></span>
                    <span class="btn-inner--text">Lihat</span>
                </base-button>
            </template>
        </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
        <el-pagination background layout="prev, pager, next" :total="ClientPaging.totalRow" :page-size="ClientPaging.totalRowPerPaging" @current-change="pageChanged">
        </el-pagination>
    </b-card-footer>
</card>
</template>

<script>
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import GetsalaryService from "@/services/salaryService.js";
import Store from "@/store";
import BaseButton from "@/components/BaseButton.vue";
// import CarianBaharu from "@/views/PindahPeruntukan/Penyedia/CarianBaharu.vue";

export default {
    name: "DASHBOARD",
    components: {
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Pagination.name]: Pagination,

    },
    data() {
        return {
            SenaraiPenjawatAwam: [{
                    CONm: "shuk"
                },
                {
                    CONm: "bob"
                }
            ],
            currentPage: 1,
            ClientPaging: {
                pagingType: 2,
                totalRow: 0,
                totalRowPerPaging: 0,
                totalPage: 0,
                memTableName: null,
                lastPage: 0,
            },
            loading: false,
        };
    },

    methods: {
        uppercase(row, column, cellValue) {
    return cellValue ? cellValue.toUpperCase() : '';
  },
        pageChanged(val) {
            this.currentPage = val;
            this.queryPageData(val);
        },
        showVal(row) {
          //console.log("nokpadfdsfds",row)
            this.$router.push({
                name: 'BUTIRAN MAKLUMAT GAJI',
                params: {
                    ICNo: row.ICNo,
                    coid: row.coid,
                }
            })
        },

        // searchProgram(Search) {
        //     console.log(Search);
        //   // this.search=Search
        //  // Search["status_permohonan"]= [1];

        //   PindahPeruntukanService.getSenaraiPermohonanPerluPerakuanInfoParam(Search)
        //     .then((resp) => {
        //       this.ClientPaging = resp.data;
        //       //console.log("pagingInfo: ", resp.data);
        //     })
        //     .then(() => {
        //       PindahPeruntukanService.getSenaraiPermohonanPerluPerakuanDataParam(
        //         Search
        //       ).then((resp) => {
        //         this.listPerluPerakuan = resp.data;
        //         //console.log("pagingData: ", resp.data);
        //       });
        //     });

        // },

        // resetPaging(Search) {
        //   this.search=Search
        //   let search = {
        //     currentPage: 1,
        //    // status_permohonan: [4],
        //   };
        //   //console.log(search);

        //   PindahPeruntukanService.getSenaraiPermohonanPerluPerakuanInfoParam(search)
        //     .then((resp) => {
        //       this.ClientPaging = resp.data;
        //       //console.log("pagingInfo: ", resp.data);
        //     })
        //     .then(() => {
        //       PindahPeruntukanService.getSenaraiPermohonanPerluPerakuanDataParam(
        //         search
        //       ).then((resp) => {
        //         this.listPerluPerakuan = resp.data;
        //         //console.log("pagingData: ", resp.data);
        //       });
        //     });
        // },

        queryPageData(currentPage) {
            this.loading = false;

            let search = {
                currentPage: currentPage,
            };

            GetsalaryService.getSenaraiPenjawatAwamSelesaiInfo(search)
                .then((resp) => {
                    this.ClientPaging = resp.data;
                    console.log("pagingInfo: ", resp.data);
                })
                .then(() => {
                    GetsalaryService.getSenaraiPenjawatAwamSelesaidata(
                        search
                    ).then((resp) => {
                        this.SenaraiPenjawatAwam = resp.data;
                        //console.log("pagingData: ", SenaraiPenjawatAwam);
                    });
                });
        },

        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },
    },

    created() {
        this.queryPageData(1);
    },
    // computed: {
    //   roleID() {
    //     return Store.state.Pengguna.roleID;
    //   },
    // },
};
</script>

<style scoped>
.table-responsive .el-table__header th {
    font-size: 16px;
    font-weight: bold;
    background-color: #f6f9fc;
    color: #000;
}

.table-responsive .el-table__body td {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.b-card-header h3 {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50; /* biru gelap profesional */
}
</style>
